export default __webpack_public_path__ + "static/test-3e058034fd530fc2510593d255653122.jpg";